import { Box } from "@chakra-ui/react";

import PhHistoryTabView from "./PhHistoryTabView";

export const PhHistoryTab = () => {
  return (
    <Box p={4}>
      <PhHistoryTabView />
    </Box>
  );
};

export default PhHistoryTab;
